/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  UsdcUsdt3poolLib,
  UsdcUsdt3poolLibInterface,
} from "../UsdcUsdt3poolLib";

const _abi = [
  {
    inputs: [],
    name: "UNKNOWN_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDC_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60ba610039600b82828239805160001a60731461002c57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe730000000000000000000000000000000000000000301460806040526004361060455760003560e01c806173f414604a578063bccda831146064578063c38cff9a14607d575b600080fd5b6051600181565b6040519081526020015b60405180910390f35b606b600281565b604051600f9190910b8152602001605b565b606b60018156fea26469706673582212202e76e196d651e6fa3b22cdf8382e1f93aabee396c38d30d60e06029f1a62390164736f6c634300080d0033";

type UsdcUsdt3poolLibConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UsdcUsdt3poolLibConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UsdcUsdt3poolLib__factory extends ContractFactory {
  constructor(...args: UsdcUsdt3poolLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "UsdcUsdt3poolLib";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<UsdcUsdt3poolLib> {
    return super.deploy(overrides || {}) as Promise<UsdcUsdt3poolLib>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): UsdcUsdt3poolLib {
    return super.attach(address) as UsdcUsdt3poolLib;
  }
  connect(signer: Signer): UsdcUsdt3poolLib__factory {
    return super.connect(signer) as UsdcUsdt3poolLib__factory;
  }
  static readonly contractName: "UsdcUsdt3poolLib";
  public readonly contractName: "UsdcUsdt3poolLib";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UsdcUsdt3poolLibInterface {
    return new utils.Interface(_abi) as UsdcUsdt3poolLibInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UsdcUsdt3poolLib {
    return new Contract(address, _abi, signerOrProvider) as UsdcUsdt3poolLib;
  }
}
